<template>
  <div>
    <div class="accordion"
         v-show="showComponent"
         :key="componentRefresh"
         :id="'ks_accordion_'+_uid"
         v-if="!collapse"
    >
      <slot></slot>
    </div>
    <div v-else class="collapse in" :class="{'show': show}" :id="collapseId ? collapseId : 'ks_accordion_'+_uid">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  /**
   tag
   name: ks-accordion
   description: accordion card
   **/
  name: 'ks-accordion',
  mixins: [checkPermissions],
  computed: {
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    }
  },
  props: {
    /**
     attribute
     name: id
     description: id
     **/
    collapseId: {
      type: String,
      default: null
    },
    collapse: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>
